import { Component, forwardRef, Injector, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig, RenderComponentBase } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-r-date-range',
  templateUrl: './r-date-range.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RDateRangeComponent),
      multi: true
    }
  ]
})
export class RDateRangeComponent extends RenderComponentBase {
  static KEY = 'r-d-date-range';

  constructor(injector: Injector) {
    super(injector);
  }

  dateFormat = 'yyyy-MM-dd';

  configChange(config: IDynamicComponentConfig) {
    if (typeof config.allowClear !== 'boolean') {
      config.allowClear = true;
    }
    // config.value = '2020-12-12,2020-12-20';
    // if (config.value && config.value.length) {
    //   let arr = config.value.split(',');
    //   config.value = arr;
    // }
    // if (config.placeholder && config.placeholder.length) {
    //   let arr = config.placeholder.split(',');
    //   config.placeholder = arr;
    // }
  }
}
